import { axiosInstance } from "../helpers/AxiosConfiguration";



export async function getOrganizationFields() {
    try {
        const response = await axiosInstance.get("/api/v1/organization/details");

        return response.data;
    } catch(error) {
        throw new Error(error);
    }
}